import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	gap: 10px;
	right: 0;
	top: 20px;
	background-color: #f5f7fa;
	width: 360px;
	height: fit-content;
	box-shadow: 0px 5px 10px #d8dee6;
	border-radius: 10px;
	padding: 12px 18px;

	header {
		display: flex;
		gap: 12px;

		h2 {
			font-size: 18px;
			color: ${tokens.color_gray_dark};
			font-weight: 400;
		}
	}

	p {
		font-size: 14px;
		color: ${tokens.color_gray_dark};
		font-weight: 500;
	}
`;
